export const markdownToHtml = (markdown: string) => {
    const listItemRegex = /\d+\.\s.*?(?=\d+\.\s|$)/g;
    const items = markdown.match(listItemRegex);

    if (!items) return markdown;

    const convertMarkdownInline = (text: string) =>
        text
            .replace(/\*\*(.+?)\*\*/g, '<strong style="font-weight: bold; color: black;">$1</strong>')
            .replace(/\*(.+?)\*/g, '<em>$1</em>')
            .replace(
                /\[([^\]]+)\]\(([^)]+)\)/g,
                '<a href="$2" style="text-decoration: underline;" target="_blank">$1</a>',
            );

    const htmlItems = items.map(item => {
        const content = item.replace(/^\d+\.\s/, '');
        return `<li style="color: black">${convertMarkdownInline(content.trim())}</li>`;
    });

    const htmlList = `<ol style="padding-left: 16px;">\n${htmlItems.join('\n')}\n</ol>`;

    const startIndex = markdown.indexOf(items[0]);
    const endIndex = markdown.lastIndexOf(items[items.length - 1]) + items[items.length - 1].length;
    const newText = markdown.slice(0, startIndex) + htmlList + markdown.slice(endIndex);

    return newText;
}